<script setup lang="ts">
import type { SliderRootEmits, SliderRootProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { SliderRange, SliderRoot, SliderThumb, SliderTrack, useForwardPropsEmits } from 'reka-ui';

const props = defineProps<
  SliderRootProps & { class?: HTMLAttributes['class']; thumbLabels?: string[]; thumbValueTexts?: string[] }
>();
const emits = defineEmits<SliderRootEmits>();

const delegatedProps = reactiveOmit(props, 'class', 'thumbLabels', 'thumbValueTexts');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <SliderRoot
    :class="
      cn(
        'relative flex h-6 w-full cursor-pointer touch-none select-none items-center data-[disabled]:pointer-events-none data-[orientation=vertical]:h-full data-[orientation=vertical]:w-6 data-[orientation=vertical]:flex-col',
        props.class,
      )
    "
    v-bind="forwarded"
  >
    <SliderTrack
      class="relative h-1 w-full grow cursor-pointer overflow-hidden rounded-full bg-gray-400 data-[orientation=vertical]:w-1"
    >
      <SliderRange
        class="absolute h-full bg-brand-primary-600 data-[orientation=vertical]:w-full data-[disabled]:bg-gray-100"
      />
    </SliderTrack>
    <SliderThumb
      v-for="(_, key) in modelValue"
      :key="key"
      :aria-label="props.thumbLabels?.[key]"
      :aria-valuetext="props.thumbValueTexts?.[key]"
      class="block h-4.75 w-4.75 cursor-grab rounded-full border-2 border-brand-primary-600 bg-white ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:cursor-grabbing disabled:pointer-events-none disabled:opacity-50 data-[disabled]:border-gray-100 data-[disabled]:bg-white data-[disabled]:opacity-100"
    />
  </SliderRoot>
</template>
